import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { z } from 'zod'

import { authenticatedRoute } from '@/app/routes/authenticated'
import { pageSearch as page, textSearch as text } from '@/shared/api/search'
import { requirePermission } from '@/shared/auth/guards'

const ticketsSearchSchema = z.object({
  page,
  search: text,
  status: z
    .enum(['pending', 'open', 'in_progress', 'waiting', 'resolved', 'closed'])
    .optional()
    .catch(undefined),
  priority: z.enum(['low', 'normal', 'high', 'urgent']).optional().catch(undefined),
  category: z.enum(['support', 'incident', 'request', 'billing', 'other']).optional().catch(undefined),
  company: text,
  project: text,
  requester: text,
  assignee: text,
  overdue: z.boolean().optional().catch(undefined),
})

export const ticketsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/tickets',
  beforeLoad: requirePermission('tickets.view'),
})

export const ticketsIndexRoute = createRoute({
  getParentRoute: () => ticketsRoute,
  path: '/',
  validateSearch: (search) => ticketsSearchSchema.parse(search),
  component: lazyRouteComponent(() => import('./pages/tickets-page'), 'TicketsPage'),
})

export const ticketsDashboardRoute = createRoute({
  getParentRoute: () => ticketsRoute,
  path: 'dashboard',
  component: lazyRouteComponent(() => import('./pages/tickets-dashboard-page'), 'TicketsDashboardPage'),
})

export const ticketNewRoute = createRoute({
  getParentRoute: () => ticketsRoute,
  path: 'new',
  beforeLoad: requirePermission('tickets.manage'),
  validateSearch: (search) => z.object({ company: text, requester: text, project: text }).parse(search),
  component: lazyRouteComponent(() => import('./pages/ticket-new-page'), 'TicketNewPage'),
})

// Navegação aninhada: Chamados › Chamado (atendimento) › Editar.
export const ticketRoute = createRoute({
  getParentRoute: () => ticketsRoute,
  path: '$ticketId',
})

export const ticketDetailRoute = createRoute({
  getParentRoute: () => ticketRoute,
  path: '/',
  component: lazyRouteComponent(() => import('./pages/ticket-page'), 'TicketPage'),
})

export const ticketEditRoute = createRoute({
  getParentRoute: () => ticketRoute,
  path: 'edit',
  beforeLoad: requirePermission('tickets.manage'),
  component: lazyRouteComponent(() => import('./pages/ticket-edit-page'), 'TicketEditPage'),
})

export const ticketsRoutes = ticketsRoute.addChildren([
  ticketsIndexRoute,
  ticketsDashboardRoute,
  ticketNewRoute,
  ticketRoute.addChildren([ticketDetailRoute, ticketEditRoute]),
])
